/**
 * @generated SignedSource<<552ca48e708c2f40ac722ad5e5281bb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryMilestonesInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneList" | "MilestonesActions">;
  readonly " $fragmentType": "RepositoryMilestonesInternal";
};
export type RepositoryMilestonesInternal$key = {
  readonly " $data"?: RepositoryMilestonesInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestonesInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "state"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryMilestonesInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        },
        {
          "kind": "Variable",
          "name": "state",
          "variableName": "state"
        }
      ],
      "kind": "FragmentSpread",
      "name": "MilestoneList"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestonesActions"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "d46689dd4de028313bbb7691e084899a";

export default node;
